export { default } from './BotonsIdiomes';
